// extracted by mini-css-extract-plugin
module.exports = {"featurePanel":"CharacterSheetCustomFeatures_featurePanel_3HaAc","v-expansion-panel-header":"CharacterSheetCustomFeatures_v-expansion-panel-header_3OlE_"};